<div class="premium-modal-wrapper">
    <ion-header class="ion-no-border premium-header">
        <div class="header-curve"></div>
        <div class="custom-toolbar">
            <div class="toolbar-content">
                <div class="icon-btn" (click)="close()">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </div>
                <div class="title-group">
                    <div class="title-main">Editar Planilla</div>
                    <div class="title-sub">Detalle de actividad diaria</div>
                </div>
                <div class="icon-btn" style="visibility: hidden;">
                    <ion-icon name="close"></ion-icon>
                </div>
            </div>
        </div>
    </ion-header>

    <ion-content class="content-bg" [fullscreen]="false">
        <div class="form-wrapper ion-padding">
            <div class="form-card">
                <!-- Fecha -->
                <div class="input-group full">
                    <label><ion-icon name="calendar-outline"></ion-icon> Fecha de Actividad</label>
                    <div class="premium-input-wrapper date-input">
                        <input type="date" [(ngModel)]="form.fecha" #dateInput>
                        <ion-icon name="calendar-outline" class="date-icon" (click)="dateInput.showPicker()"></ion-icon>
                    </div>
                </div>

                <div class="worker-summary" *ngIf="data">
                    <div class="avatar" [class.night]="data.turno === 'N'">
                        {{ data.nombre.charAt(0) }}
                    </div>
                    <div class="info">
                        <h2>{{ data.nombre }}</h2>
                        <p>{{ data.rol || 'Trabajador' }}</p>
                        <span class="turno-badge" [class.night]="data.turno === 'N'">
                            {{ data.turno === 'D' ? '☀️ Turno Diurno' : '🌙 Turno Nocturno' }}
                        </span>
                    </div>
                    <div class="total-summary-box">
                        <span class="lbl">Total Devengado</span>
                        <span class="val">${{ ((form.monto || 0) + (form.extra || 0) - (form.descuento || 0)) | number:'1.2-2' }}</span>
                    </div>
                </div>

                <!-- Subcontract Control -->
                <div class="input-group full">
                    <label><ion-icon name="business-outline"></ion-icon> ¿Es Subcontrato?</label>
                    <div class="radio-group-modern">
                        <div class="radio-box" [class.active]="!form.subcontrato" (click)="form.subcontrato = false">
                            <span>No</span>
                        </div>
                        <div class="radio-box active-val" [class.active]="form.subcontrato"
                            (click)="form.subcontrato = true">
                            <span>Sí</span>
                        </div>
                    </div>
                </div>

                <div class="shift-control-card">
                    <div class="shift-option" [class.active]="form.turno === 'D'" (click)="updateShift('D')">
                        <span class="icon">☀️</span>
                        <span class="label">Diurno</span>
                        <span class="price">${{ displayCostoDia }}</span>
                    </div>
                    <div class="shift-option night" [class.active]="form.turno === 'N'" (click)="updateShift('N')">
                        <span class="icon">🌙</span>
                        <span class="label">Nocturno</span>
                        <span class="price">${{ displayCostoNoche }}</span>
                    </div>
                </div>

                <!-- Grid for Amounts -->
                <div class="grid-inputs triple">
                    <div class="input-group">
                        <label><ion-icon name="cash-outline"></ion-icon> Pago</label>
                        <div class="premium-input-wrapper">
                            <input type="number" [(ngModel)]="form.monto" placeholder="0.00">
                        </div>
                    </div>

                    <div class="input-group">
                        <label><ion-icon name="add-circle-outline"></ion-icon> Extra</label>
                        <div class="premium-input-wrapper positive">
                            <input type="number" [(ngModel)]="form.extra" placeholder="0">
                        </div>
                    </div>

                    <div class="input-group">
                        <label><ion-icon name="remove-circle-outline"></ion-icon> Descuento</label>
                        <div class="premium-input-wrapper negative">
                            <input type="number" [(ngModel)]="form.descuento" placeholder="0">
                        </div>
                    </div>
                </div>


                <!-- Note -->
                <div class="input-group full">
                    <label><ion-icon name="document-text-outline"></ion-icon> Nota / Comentario</label>
                    <div class="premium-input-wrapper">
                        <textarea rows="3" [(ngModel)]="form.comentario"
                            placeholder="Escribe una nota opcional..."></textarea>
                    </div>
                </div>
            </div>
        </div>
    </ion-content>

    <div class="form-footer-actions">
        <ion-button fill="outline" class="delete-modal-btn" (click)="delete()">
            <ion-icon name="trash-outline" slot="start"></ion-icon>
            Eliminar
        </ion-button>
        <ion-button class="save-btn" (click)="save()">
            <ion-icon name="checkmark-done-outline" slot="start"></ion-icon>
            Guardar Cambios
        </ion-button>
    </div>
</div>